function invariant(expectedCondition, message) {
  if (!expectedCondition) {
    throw new Error(message);
  }
}
function generateId() {
  return (Date.now() * Math.random()).toString(36);
}
function clone(data) {
  return JSON.parse(JSON.stringify(data));
}

/**
 * Check if the value is a plain object
 */
function isPlainObject(obj) {
  return !!obj && obj.constructor === Object && Object.getPrototypeOf(obj) === Object.prototype;
}

/**
 * A utility function that performs a deep equality check between two values.
 * It handles plain objects, arrays, and primitive values only.
 */
function deepEqual(left, right) {
  if (Object.is(left, right)) {
    return true;
  }
  if (left == null || right == null) {
    return false;
  }

  // Compare plain objects
  if (isPlainObject(left) && isPlainObject(right)) {
    var prevKeys = Object.keys(left);
    var nextKeys = Object.keys(right);
    if (prevKeys.length !== nextKeys.length) {
      return false;
    }
    for (var key of prevKeys) {
      if (!Object.prototype.hasOwnProperty.call(right, key) || !deepEqual(left[key], right[key])) {
        return false;
      }
    }
    return true;
  }

  // Compare arrays
  if (Array.isArray(left) && Array.isArray(right)) {
    if (left.length !== right.length) {
      return false;
    }
    for (var i = 0; i < left.length; i++) {
      if (!deepEqual(left[i], right[i])) {
        return false;
      }
    }
    return true;
  }
  return false;
}

/*
 * Removes File object from the FormValue.
 * Used to avoid serialzing/sending File object back to the client.
 */
function stripFiles(value) {
  var json = JSON.stringify(value, (_, value) => {
    // If the current value is a File, return undefined to omit it
    if (typeof File !== 'undefined' && value instanceof File) {
      return undefined;
    }
    return value;
  });
  return JSON.parse(json);
}

export { clone, deepEqual, generateId, invariant, isPlainObject, stripFiles };
